import PromptsContextMenuWrapper from '@/components/navigation/menu/PromptsContextMenuWrapper';
import { useApplication } from '@/hooks/useApplication';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { FC } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

type TreePromptsProps = {
  openPromptsDialog: (id: number) => void;
  openNewDialog: () => void;
  openAddDialog: (id: number) => void;
  openEditDialog: (id: number) => void;
};

const TreePrompts: FC<TreePromptsProps> = (props) => {
  const { application } = useApplication();

  return (
    <StyledTreeItem itemId='prompts' label={<TreeLabel icon={VolumeUpIcon} label='Prompts' />}>
      <StyledTreeItem
        itemId='prompts.all'
        label={<TreeLabel icon={VolumeUpIcon} label='All Prompts' />}
        onClick={() => props.openPromptsDialog(0)}
      />
      {application?.promptGroups?.map((group) => (
        <PromptsContextMenuWrapper
          id={group.id}
          key={group.id}
          openNewDialog={props.openNewDialog}
          openAddDialog={props.openAddDialog}
          openEditDialog={props.openEditDialog}
        >
          <StyledTreeItem
            itemId={`prompts.${group.name}`}
            label={<TreeLabel icon={VolumeUpIcon} label={group.name} />}
            onClick={() => props.openPromptsDialog(group.id)}
          />
        </PromptsContextMenuWrapper>
      ))}
    </StyledTreeItem>
  );
};

export default TreePrompts;
